import { render, staticRenderFns } from "./lookImage.vue?vue&type=template&id=2c3c99ab&scoped=true&"
import script from "./lookImage.vue?vue&type=script&lang=js&"
export * from "./lookImage.vue?vue&type=script&lang=js&"
import style0 from "./lookImage.vue?vue&type=style&index=0&id=2c3c99ab&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3c99ab",
  null
  
)

export default component.exports